export default __webpack_public_path__ + "static/media/end1img.f4a8f221.png";